<template>
	<div>
		<a-form ref="confFormRef" :model="modelRef" scrollToFirstError name="form" :labelCol="{span: 6, xxl: 5}" :wrapperCol="{span: 16, xxl: 15 }" @finish="onSend">
			<a-spin :spinning="loading">
				<a-form-item label="白名单id" name="uidListStr" :rules="[{required: true, message: '必填项不允许为空'}]" extra="多个请用英文逗号,进行分隔">
					<a-input v-model:value="modelRef.uidListStr" placeholder="请输入白名单id"></a-input>
				</a-form-item>
			</a-spin>
		</a-form>
	</div>
</template>

<script>
	import { buttonWhiteSetting } from '@/service/modules/cinema';
	export default {
		props: {
			modelData: {
				type: Object,
				default:() => {}
			},
		},
		data () {
			return {
				loading: false,
				modelRef: {}
			}
		},
		created() {
			this.modelRef = this.$deepClone(this.modelData);
		},
		methods: {
			onSubmit() {
				if (this.loading) return;
				this.$refs.confFormRef.validateFields().then((e) => {
					this.onSend();
				});
			},
			async onSend() {
				let postData = JSON.parse(JSON.stringify(this.modelRef));
				this.loading = true;
				let ret = await buttonWhiteSetting(postData);
				this.loading = false;
				if (ret.code === 200) {
					this.$message.success('修改成功');
					this.$emit('close');
				}
			}
		}
	}
</script>

<style>
</style>